import React, { Component } from 'react';
import { find } from 'lodash';
import { compose } from 'recompose';
import { FormikProps } from 'formik';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { withGroupIcons, IWithGroupIcons } from 'providers/queries';
import { IGroupForm } from '../../types';

interface IProps {
  hexColor: string;
  formikProps: FormikProps<IGroupForm>;
  size: number;
}

interface IPropsEnhanced extends IProps, IWithGroupIcons, WithStyles<typeof styles> {}

interface IState {
  localUrl: string;
}

const { REACT_APP_IMGIX_HOST } = process.env;
const MIN_SIZE = 2; // imgix min - protecting against 0

const styles = () =>
  createStyles({
    imageWrapper: {
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
  });

const enhancers = compose<IPropsEnhanced, IProps>(withGroupIcons, withStyles(styles));

class Image extends Component<IPropsEnhanced, IState> {
  state: IState;

  constructor(props: IPropsEnhanced) {
    super(props);

    const localUrl = this.getLocalUrl(props);
    this.state = { localUrl };
  }

  componentDidUpdate(prevProps: IPropsEnhanced) {
    const currentImage = this.getImageObject();
    const prevImage = this.getImageObject(prevProps);

    const currentLocalUri = currentImage && currentImage.localUri;
    const prevLocalUri = prevImage && prevImage.localUri;

    if (!currentLocalUri && !prevLocalUri) {
      return;
    }

    if (currentLocalUri !== prevLocalUri) {
      const localUrl = this.getLocalUrl();
      this.setState({ localUrl });
    }
  }

  getImageObject(props = this.props) {
    const { formikProps } = props;
    const { values } = formikProps;

    return values.image;
  }

  getLocalUrl(props = this.props) {
    const image = this.getImageObject(props);

    if (!image || !image.localUri) {
      return '';
    }

    return window.URL.createObjectURL(image.localUri);
  }

  getIconUrl() {
    const { formikProps, groupIcons, size } = this.props;

    const { icon } = formikProps.values;
    const safeSize = Math.max(MIN_SIZE, size);
    const match = find(groupIcons, ['group_icon', icon]);

    return `${REACT_APP_IMGIX_HOST}/${match.file_key}?auto=format&h=${safeSize}&w=${safeSize}`;
  }

  getSrc() {
    const { size } = this.props;
    const { localUrl } = this.state;

    const src = this.getIconUrl();
    const image = this.getImageObject();
    const safeSize = Math.max(MIN_SIZE, size);

    if (!image) {
      return src;
    }

    const savedImageUrl = `${REACT_APP_IMGIX_HOST}/${image.key}?auto=format&h=${safeSize}&w=${safeSize}`;
    return image.localUri ? localUrl : savedImageUrl;
  }

  render() {
    const { classes, hexColor, size } = this.props;
    const src = this.getSrc();

    return (
      <div
        className={classes.imageWrapper}
        style={{
          width: size,
          height: size,
          backgroundColor: hexColor,
          backgroundImage: `url(${src})`,
        }}
      />
    );
  }
}

export default enhancers(Image);
